import EventType from '@/models/ElasticApmRum/EventType';
import SessionEventType from '@/models/Metrics/SessionEventType';
import SessionStatus from '@/models/SessionStatus';

export default function getSessionEventTypeFromEventType(
    type: EventType | string
): (...args: string[]) => SessionEventType | null {
    switch (type) {
        case EventType.INPUT:
            return () => SessionEventType.INPUT;
        case EventType.WRONG_INPUT:
            return () => SessionEventType.INPUT;
        case EventType.CLICK:
            return () => SessionEventType.CLICK;
        case EventType.WAITING:
            return () => null;
        case EventType.PLAYING_INSTRUCTION_SOUND:
            return () => SessionEventType.PLAYING_SOUND;
        case EventType.RECORDING:
            return () => SessionEventType.RECORD_START;
        case EventType.POP:
            return () => SessionEventType.WARNING_TRIGGERED;
        case EventType.DROP:
            return () => SessionEventType.RES_MOVED;
        case EventType.SESSION_STATUS:
            return (status: string) => {
                switch (status) {
                    case SessionStatus.STARTED:
                        return SessionEventType.SESSION_START;
                    default:
                        return null;
                }
            };
        default:
            return () => null;
    }
}
